<template>
	<div v-html="blockContent"></div>
</template>

<script>
	import { renderCustomPageContent } from '@/modules/custom/customPageTokens';
	import { resolvePortalBranding } from '@/utils/portalBranding';

	export default {
		name: 'ContentBlock',

		props: {
			index: { type: Number, required: true },
			content: { type: Array, required: false, default: () => [] },
		},

		computed: {
			blockContent() {
				if (this.index < 0 || this.index >= this.content.length) {
					return '';
				}
				return renderCustomPageContent(
					this.content[this.index] || '',
					this.$store.state.clientPortalContext,
					resolvePortalBranding(this.$store.state.domain, this.$vuetify.theme.dark ? 'dark' : 'light')
				);
			},
		},
	};
</script>

<style scoped lang="scss"></style>
